import React, { useEffect, useState } from 'react';
import { PhoneIcon, MessageCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { contacto } from '../data/site';
export function Header() {
  const [compacto, setCompacto] = useState(false);
  useEffect(() => {
    const onScroll = () => setCompacto(window.scrollY > 64);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b backdrop-blur-md transition-[background-color,border-color,box-shadow,padding] duration-300 ease-out ${compacto ? 'border-white/10 bg-[#0D0D0D]/80 py-2 shadow-lg shadow-black/40' : 'border-white/5 bg-[#0D0D0D]/45 py-4 shadow-sm shadow-black/20'}`} data-id="element-51" data-mp="2wkqjfvxrnq4i">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-6 sm:flex-row sm:justify-between sm:gap-6 lg:px-12" data-id="element-52" data-mp="3bbzdch8pbxng">
        <a href="#hero" className={`font-serif tracking-[0.28em] text-white transition-[color,font-size] duration-300 ease-out hover:text-[#E0A526] ${compacto ? 'text-base sm:text-lg' : 'text-lg sm:text-xl'}`} data-id="element-53" data-mp="2wkkwt7hste14">
          MAGIA PODEROSA
        </a>

        <div className="flex w-full items-center justify-center gap-3 sm:w-auto sm:justify-end" data-id="element-54" data-mp="2hnttin507i68">
          <CtaButton href={contacto.telefonoHref} variante="azul" compacto atencion className="flex-1 sm:flex-none" icon={<PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-56" data-mp="3aelpbji5q4t1" />} data-id="element-55" data-mp="3fb2nl6j2lzju">
            LLAMAR
          </CtaButton>
          <CtaButton href={contacto.whatsappHref} variante="verde" compacto atencion className="flex-1 sm:flex-none" icon={<MessageCircleIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="3tb3mwhjosyx7" />} data-id="element-57" data-mp="30mpr88g2meot">
            WHATSAPP
          </CtaButton>
        </div>
      </div>
    </header>;
}